var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgByReceiver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9971 5.10284L16 10.6815V10.9262C16 13.6136 14.3709 15.2027 11.6138 15.2027H4.38685C1.62915 15.2027 0 13.6136 0 10.9262V5.07302C0 2.38563 1.62915 0.802734 4.38685 0.802734H11.611C14.368 0.802734 15.9971 2.38563 15.9971 5.07302V5.10284Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3788 5.74328C10.3788 7.15304 9.24884 8.28344 7.8386 8.28344C6.42884 8.28344 5.29844 7.15304 5.29844 5.74328C5.29844 4.33353 6.42884 3.20312 7.8386 3.20312C9.24884 3.20312 10.3788 4.33353 10.3788 5.74328ZM4 11.1591C4 9.85345 5.76832 9.52705 7.83856 9.52705C9.92032 9.52705 11.6771 9.86497 11.6771 11.1711C11.6771 12.4771 9.9088 12.8031 7.83856 12.8031C5.75728 12.8031 4 12.4651 4 11.1591Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByReceiver);
export default __webpack_public_path__ + "static/media/by_receiver.c1d74cf01b552a5feccc814fd08556ef.svg";
export { ForwardRef as ReactComponent };